module.exports = __webpack_public_path__ + "img/item_dine_out.d497e786.jpg";